<template>
    <div class="IpcSimpleViewerComponent">
        <span v-show="isIPC">
            <p>{{lang.infotext_1}}:</p>
            <div class="svgContainer">

                <div :id="'svgSimplePCB_' + name" class="svgSimplePCB"></div>
            </div>
        </span>

    </div>
</template>

<script>
//import { mapState, mapMutations, mapActions, mapGetters, mapTypes } from 'vuex'

//import panzoom from "panzoom";
import { mapGetters } from "vuex";
export default {
    name: "IpcSimpleViewerComponent",
    data() {
        return {
            id: "IpcSimpleViewerComponent",
            svgData: "",
            isIPC: false,

        };
    },
    props: {
        name: String,
        //zooming: Boolean,
        lang: Object,
    },
    computed: {
        ...mapGetters({
            //selectedPartBomRow: 'selectedPartBomRow',

        }),
        
        
        reloadedAfterActionComplex() {
            return this.$store.getters.reloadedAfterActionComplex;
        },
        revisionId() {
            if (this.$route.path == "/ProjectManager/ProjectDetails") {
                return this.$route.query.revisionId;
            }
            if (this.$route.path == "/ProjectManager/ProjectBom") {
                return this.$route.query.revisionId;
            }
            return this.$store.getters.selectedRows[0].col___revisionId.revisionId;
        }
    },
    created() {
        this.isIPC = false;
        this.getSVG();
    },
    watch: {
        reloadedAfterActionComplex: {
            handler: function (newValue) {

                for (let el in newValue) {
                    if (newValue[el].name == this.id) {
                        if (newValue[el].status == true) {
                            this.isIPC = false;
                            this.getSVG();

                            newValue[el].status = false;

                            this.$store.dispatch("reloadAfterActionComplex", newValue[el]);
                        }
                    }
                }
            },
            deep: true

        },
        
        revisionId: function () {
            this.isIPC = false;
            this.getSVG();
        },
        
        
        
    },
    methods: {
        
        getSVG() {
            
            let vue = this;

            const obj = {
                projectRevisionId: this.revisionId
            };

            
            this.$store.dispatch(this.$store.getters.sectionPrefix + "_getSvgFromIpc", obj)
                .then((result) => {
                    console.log(result)

                    //if (result.status == "OK"){
           
                    vue.svgViewboxAdjusted = 'notok';
                    vue.loadSVG(result);


                    //}

                })
        },
calculateViewbox(){
            let containerDiv = document.getElementById("svgSimplePCB_" + this.name);
            if(!containerDiv){
                return;
            }
            let vue=this;
            //console.log('adjusted:');
            //console.log(vue.svgViewboxAdjusted);
            if(vue.svgViewboxAdjusted == "ok"){
                return;
            }
            if(null == containerDiv.offsetParent){
                //console.log('doooooooooooooooopa');
                setTimeout(vue.calculateViewbox,200);
                return
            }
            //console.log('step0');

            let svgOnBoard = containerDiv.children[0];
            if(!svgOnBoard){
                return;
            }
            var viewerSettings = {additionalMargin:2}
            
            let acc = {};
            //console.log('step1');

            for (let el of svgOnBoard.children) {
                //console.log('step2');
                //console.log(el);
                if(el.getBBox){
                    let { x, y, width, height } = el.getBBox();
                    if (!acc.xMin || x < acc.xMin) acc.xMin = x;
                    if (!acc.xMax || x + width > acc.xMax) acc.xMax = x + width;
                    if (!acc.yMin || y < acc.yMin) acc.yMin = y;
                    if (!acc.yMax || y + height > acc.yMax) acc.yMax = y + height;
                }
            };
            if(acc.xMax==0 && acc.xMin ==0 && acc.yMax==0 && acc.yMin ==0 ){
                //console.log('doooooooooooooooopa2');
                setTimeout(vue.calculateViewbox,200);
                return
            }
            const viewbox = `${acc.xMin-viewerSettings.additionalMargin} ${acc.yMin-viewerSettings.additionalMargin} ${acc.xMax - acc.xMin+(2*viewerSettings.additionalMargin)} ${acc.yMax - acc.yMin+(2*viewerSettings.additionalMargin)}`;

            svgOnBoard.setAttribute('viewBox', viewbox);
            vue.svgViewboxAdjusted = 'ok';
        }
        ,
        async loadSVG(blob) {
            let vue =this;
            this.svgData = await new Response(blob).text();
            let ql = document.querySelector(`#svgSimplePCB_${this.name}`);
            
            if (ql == null) {
                return;
            }
            ql.innerHTML = "";
            //ql.innerHTML = this.svgData;
            const hassvg = ql.querySelector("svg");

            if (this.svgData.includes('<tspan dy="1" dx="1">NO IPC</tspan>') == true) {
                
                this.isIPC = false;
                return;
            }
            this.isIPC = true;
            var parser = new DOMParser();
            var doc = parser.parseFromString(this.svgData, "image/svg+xml");
            doc.documentElement.setAttribute("width", "100%");
            doc.documentElement.setAttribute("height", "100%");
            doc.documentElement.setAttribute("preserveAspectRatio", "xMidYMid meet");

            // if (this.zooming) {
            //     let instance = panzoom(ql, {
            //         minZoom: 1
            //     });
            // }

            if (ql.children.length < 7) {
                ql.appendChild(doc.documentElement);
                vue.calculateViewbox();
            }
            this.addEventsToParts()
        },
        addEventsToParts() {
            let vue = this;
            let base = document.getElementById("svgSimplePCB_" + this.name);
            const parts = base.querySelectorAll('[id*="svg__"]')



            for (let i = 0, lei = parts.length; i < lei; i++) {


                const style = window.getComputedStyle(parts[i], null);

                //parts[i].style.stroke = "#E87C1E";
                parts[i].style.fill = "#0f0";
                parts[i].style["fill-opacity"] = "0.0";
                

                let temp = parts[i].id.split("__");
                
                parts[i].setAttribute("id", "simple__"+parts[i].id)
            }
            
        },

        
    },

};
</script>

<style lang="scss">
.IpcSimpleViewerComponent {
    display: block;
    overflow: hidden;

    //padding: 10px 0 10px 0;
    .svgContainer {
        background-color: #000;
        display: block;
        overflow: hidden;
        width: 100%;
        height: 100%;
    }

    .svgSimplePCB {
        background-color: #000;
        display: block;
        width: 100%;
        overflow: hidden;
    }

    .element-layers {

        .list-group-item {
            margin-top: 0px;
        }

        .layers-checkboxes {
            margin-top: 10px;
        }
    }

    .pulse {
        fill: rgba(#0f0, .5);
        animation: pulse2 1.5s ease-in-out;

    }

    @keyframes pulse2 {
        0% {

            opacity: 0;
        }

        50% {
            opacity: 1;
        }

        100% {

            opacity: 0;
        }

        0% {

            opacity: 0;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/IpcSimpleViewerComponent.vue